import React from "react";
import "./Footer.css"; // Import the external CSS file
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="page-container">
      <div className="main-content">
        {/* Your main content goes here */}
      </div>
      <footer id="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h4>About</h4>
            <Link to="/aboutmaharishi">About Maharishi</Link>
            <Link to="/genesis">Genesis</Link>
            <Link to="/organisationalchart">Organisation Chart</Link>
            <Link to="/charter">Charter</Link>
          </div>

          <div className="footer-section">
            <h4>Our Work</h4>
            <Link to="/associated_programs">Associated Programs</Link>
            <Link to="/opportunities">Opportunities</Link>
            <Link to="/earlycareerresearcher">Early career Researchers</Link>
            {/* <Link to="/partnership">Partnerships</Link> */}
          </div>

          <div className="footer-section">
            <h4>Crops</h4>
            <Link to="/millets">Millets</Link>
            <Link to="/ancient_grains">Ancient Grains</Link>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <Link to="/contact">General Enquiry</Link>
            <Link to="/exhibitor-services">Exhibitor Enquiry</Link>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="#" className="fab fa-linkedin"></a>
              <a href="#" className="fab fa-facebook-f"></a>
              <a href="#" className="fab fa-twitter"></a>
              <a href="#" className="fab fa-youtube"></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Footer;